  export enum SubscriptionType {
    MONTHLY = "monthly",
    ANNUAL = "annual",
    FREE = "free"
  }
  
  export const SUBSCRIPTION_PRICES: Record<SubscriptionType, number> = {
    [SubscriptionType.MONTHLY]: 47,
    [SubscriptionType.ANNUAL]: 340,
    [SubscriptionType.FREE]: 0,
  };
  